"use client";

import { useMediaQuery } from "@chakra-ui/react";
import { Box } from "@revoo/design-system/ui/Box/Box";
import { Button } from "@revoo/design-system/ui/Button/Button";
import { Flex } from "@revoo/design-system/ui/Flex/Flex";
import { Icon } from "@revoo/design-system/ui/Icon/Icon";
import { useTheme } from "@revoo/design-system/providers/ThemeProvider";

import { Trans } from "react-i18next";
import Link from "next/link";
import React from "react";
import FormLoginProvider from "@/libs/auth/pages/Login/FormLoginProvider";
import DisclosureProvider from "@/libs/shared/providers/DisclosureProvider";
import { FormLogin } from "./FormLogin";

export function Login() {
  const { images, Logo, device } = useTheme();
  const [isLargerThanMd]: boolean[] = useMediaQuery(device.md, { ssr: false });

  // noinspection Annotator
  return (
    <Flex
      h="100vh"
      w="full"
      alignItems="center"
      justify="center"
      backgroundImage={["none", "none", "none", images.loginBg]}
      backgroundSize="cover"
      bgPosition={"center"}
      zIndex={-1}
      direction="column"
      gap={3.5}
    >
      <Box
        display={["none", "none", "none", "block"]}
        position={"absolute"}
        top={0}
        left={0}
        right={0}
        bottom={0}
        backgroundImage={
          "linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.103353) 29%, rgba(0, 0, 0, 0.708397) 100%)"
        }
      />
      <Icon
        h={isLargerThanMd ? 16 : 7}
        w={isLargerThanMd ? 28 : "auto"}
        icon={Logo}
        mb={8}
        position={"absolute"}
        top={12}
        left={["50%", "50%", "50%", 16]}
        transform={[
          "translateX(-50%)",
          "translateX(-50%)",
          "translateX(-50%)",
          "none",
        ]}
      />
      <Flex
        minW={["auto", "auto", "auto", "450px"]}
        margin={[12, "0 auto"]}
        bg="palette.secondary.100"
        p={[12, 12, 12, 10]}
        borderRadius="lg"
        position="relative"
        zIndex={1}
      >
        <FormLoginProvider>
          <DisclosureProvider>
            <FormLogin />
          </DisclosureProvider>
        </FormLoginProvider>
      </Flex>
      <Flex
        h={24}
        minW={["auto", "auto", "auto", "450px"]}
        margin={[12, "0 auto"]}
        bg="palette.secondary.100"
        px={6}
        borderRadius="lg"
        position="relative"
        zIndex={1}
        alignItems="center"
        justifyContent={{
          base: "center",
          md: "space-between",
        }}
        direction={{
          base: "column",
          md: "row",
        }}
        gap={{
          base: 4,
          md: 0,
        }}
      >
        <Trans i18nKey="Login:dont_have_an_account" />
        <Link href={"/signup"}>
          <Button variant="solid">
            <Trans i18nKey="Login:register" />
          </Button>
        </Link>
      </Flex>
    </Flex>
  );
}
